<template>
  <v-container>
    <v-row class="px-3">
      <v-divider />
    </v-row>
    <v-row class="pl-3">
      <v-btn depressed class="my-6" color="primary" outlined style="text-transform: none;width: 30%;min-width: 200px;"
        :disabled="resData.table.length===0"
        @click="tableDownload()">
        Table Download
      </v-btn>
    </v-row>
    <v-row class="mb-6 px-3">
      <v-img
        v-bind:src="resData.display_xyz"
      ></v-img>
    </v-row>
    <v-row class="pl-1">
      <iframe
        width="800" height="400"
        style="border:none;"
        v-bind:srcdoc="resData.html"
      ></iframe>
    </v-row>
    <v-row class="mb-6 pl-3">
      <v-data-table
        :headers="headers"
        v-bind:items="resData.table"
        :items-per-page="-1"
        dense
        class="elevation-1"
      ></v-data-table>
    </v-row>
    <v-dialog
      v-model="dialog"
      persistent
      width="450"
    >
      <v-card height="150">
        <v-card-title class="text-subtitle-1">
          Failed to download data.<br />
          Please wait a moment and try again.
        </v-card-title>
        <v-card-actions>
          <v-btn
            @click="dialog = false"
            outlined
            color="red lighten-2"
            class="text-align:start ml-auto"
          >
            OK
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
export default {
  name: 'ReportForm',
  props: {
    resData: {
      type: Object
    }
  },
  data () {
    return {
      headers: [
        {
          text: 'cluster_id',
          align: 'start',
          sortable: false,
          value: 'cluster_id'
        },
        { text: 'peak_x', value: 'peak_x' },
        { text: 'peak_y', value: 'peak_y' },
        { text: 'peak_z', value: 'peak_z' },
        { text: 'cluster_mean', value: 'cluster_mean' },
        { text: 'volume_mm', value: 'volume_mm' },
        { text: 'aal', value: 'aal' }
      ],
      dialog: false
    }
  },
  methods: {
    tableDownload () {
      try {
        const bom = new Uint8Array([0xef, 0xbb, 0xbf])
        const blob = new Blob([bom, this.resData.csv], { type: 'text/csv' })
        const link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        link.download = 'table_data.csv'
        link.click()
      } catch (e) {
        console.log(e)
        this.dialog = true
      }
    }
  }
}
</script>

<style scoped>
/* 行の色を変更 */
.v-data-table td {
  background: #eeeeee; /* 偶数行：grey lighten-3*/
}
.v-data-table tr:nth-child(odd) td {
  background: #fafafa; /* 奇数行：grey lighten-5*/
}
</style>
